import React from 'react';
import { FormattedMessage } from 'react-intl';
import { appNotification } from '../../containers/App/appNotification';
import { createLocalNotification } from '../../containers/App/utils';

const notification = createLocalNotification('MyAccount', {
    error: (
        <FormattedMessage
            id='front-app/MyAccount/Notification/Error:title'
            defaultMessage='My Account Error'
        />
    ),
    warning: (
        <FormattedMessage
            id='front-app/MyAccount/Notification/Warning:title'
            defaultMessage='My Account Warning'
        />
    ),
    info: (
        <FormattedMessage
            id='front-app/MyAccount/Notification/Info:title'
            defaultMessage='My Account Info'
        />
    ),
    success: (
        <FormattedMessage
            id='front-app/MyAccount/Notification/Info:title'
            defaultMessage='My Account Info'
        />
    ),
});

export const myAccountNotifications = {
    updatedSuccessfully: notification.success(appNotification.texts.updatedSuccessfully),
    unknownError: (details?: JSX.Element | string) => (
        notification.error(appNotification.texts.unknownError(details))
    ),
};
